// setFcmToken.js
'use strict';

import mergeMeData from '../action/mergeMeData.js';
import {
  initFcm,
  getFcmMessaging,
  getFcmToken,
  deleteFcmToken,
} from '../resource/fcm.js';
import { hasServiceWorker } from '../serviceWorker/helpers.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { FCM_TOKEN_COOLDOWN_SECS } from '../RemoteConfigKeys.js';

/**
 * Bind fcm
 * @kind action
 * @param {bool} [shouldBypassCooldown=false]
 * @return {Promise} Action promise.
 */
const setFcmToken =
  ({ shouldBypassCooldown = false } = {}) =>
  async (dispatch, getState) => {
    const state = getState();
    const isAuthed = !!getMeData(state, 'id');
    const permission = getOperationData(state, ['permission'], 'notification');
    const lastFcmTokenTimestamp =
      getMeData(state, 'lastFcmTokenTimestamp') || 0;
    const fcmTokenCoolDownSecs = getRemoteConfigData(
      state,
      FCM_TOKEN_COOLDOWN_SECS
    );

    if (
      !isAuthed ||
      !window.PushManager ||
      permission !== 'granted' ||
      !hasServiceWorker
    )
      return;

    // cool down
    const now = Date.now();
    if (
      now - lastFcmTokenTimestamp < fcmTokenCoolDownSecs * 1000 &&
      !shouldBypassCooldown
    )
      return;

    try {
      if (!getFcmMessaging()) await initFcm();

      // always delete previous fcm token
      await deleteFcmToken();

      const fcmToken = await getFcmToken();
      if (fcmToken) {
        dispatch(mergeMeData({ field: 'fcmToken', value: fcmToken }));
        dispatch(
          mergeMeData({
            field: 'lastFcmTokenTimestamp',
            value: Date.now(),
          })
        );
      }
      // eslint-disable-next-line no-empty
    } catch (error) {}
  };

export default setFcmToken;
